"use client"

import React from 'react';
import { FaStar } from 'react-icons/fa';

export default function StarRating({ numberOfStars, totalStars }) {
    return (
        <div style={{ display: 'flex' }}>
            {Array.from({ length: totalStars }, (_, index) => (
                <FaStar
                    key={index}
                    style={{
                        color: index < numberOfStars ? "#ffd700" : "#ccc",
                        marginRight: '4px'
                    }}
                />
            ))}
        </div>
    );
};